import { YupSchema } from 'services/yup/types'
import { yupNumber, yupObject, yupString } from 'services/yup'
import {
  PackageBase,
  ProductPreset,
} from 'services/api/entities/catalog/packages/common'
import { ActivityStatus } from 'types/form'

export const presetBaseVS: YupSchema<ProductPreset> = yupObject().shape({
  id: yupNumber(),
  name: yupString(),
})

export const packageBaseVS: YupSchema<PackageBase> = yupObject().shape({
  id: yupNumber(),
  name: yupString().required(),
  description: yupString().required(),
  status: yupString<ActivityStatus>().required(),
})
